import axios from './_nestAxios'

export const obtenerAsIslaControl = () => axios.get('/islas-combustibles', { params: { tipoConsulta: 'isla-control' } })
export const obtenerAsSelfVenta = (idIsla, idListaPrecio) =>
  axios.get('/islas-combustibles', {
    params: { tipoConsulta: 'self-venta', idIsla: idIsla, idListaPrecio: idListaPrecio }
  })
export const nuevo = data => axios.post('/islas-combustibles', data)
export const eliminarxId = id => axios.delete(`/islas-combustibles/${id}`)
